var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageAddLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 10V12H15.9997V13.3333H13.9997V15.3333H12.6663V13.3333H10.6663V12H12.6663V10H13.9997ZM14.005 2C14.3703 2 14.6663 2.29667 14.6663 2.662V8.66667H13.333V3.33333H2.66634V12.666L9.33301 6L11.333 8V9.886L9.33301 7.886L4.55101 12.6667H9.33301V14H1.99434C1.81888 13.9998 1.65067 13.93 1.52667 13.8059C1.40266 13.6817 1.33301 13.5135 1.33301 13.338V2.662C1.33423 2.48692 1.40427 2.31934 1.52802 2.19548C1.65176 2.07161 1.81926 2.0014 1.99434 2H14.005ZM5.33301 4.66667C5.68663 4.66667 6.02577 4.80714 6.27582 5.05719C6.52587 5.30724 6.66634 5.64638 6.66634 6C6.66634 6.35362 6.52587 6.69276 6.27582 6.94281C6.02577 7.19286 5.68663 7.33333 5.33301 7.33333C4.97939 7.33333 4.64025 7.19286 4.3902 6.94281C4.14015 6.69276 3.99967 6.35362 3.99967 6C3.99967 5.64638 4.14015 5.30724 4.3902 5.05719C4.64025 4.80714 4.97939 4.66667 5.33301 4.66667Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAddLine);
export default __webpack_public_path__ + "static/media/image_add_line.88a9b90c7bb522cc23e923a620c8f8c4.svg";
export { ForwardRef as ReactComponent };